import { render, staticRenderFns } from "./LinkSettingsModal.vue?vue&type=template&id=06f63a32&scoped=true&"
import script from "./LinkSettingsModal.vue?vue&type=script&lang=js&"
export * from "./LinkSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./LinkSettingsModal.vue?vue&type=style&index=0&id=06f63a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f63a32",
  null
  
)

export default component.exports